import React, { Component } from 'react';
import { Wrapper, Container, Heading, Tagline, Groups, Testimonial, Text } from './styles';
import SpeechMarks from './SpeechMarks';

class Feedback extends Component {
  render() {
    return (
      <Wrapper>
        <Container>
          <Heading>What people say about us</Heading>
          <Tagline>
            Rather than commission questionable blog posts and anonymise dubious feedback, here are a few of the
            personal testimonies we received...
          </Tagline>

          <Groups>
            <div>
              <Testimonial>
                <SpeechMarks />
                <Text>
                  Brilliant course that gave a comprehensive basis for preparation for the SJT. Great information on the practicalities of taking the SJT, timing and exam tips. The mock questions were extremely useful and representative, especially with the new section of questions. Thank you!
                  <span>Harriett Haswell</span>
                </Text>
              </Testimonial>
              <Testimonial>
                <SpeechMarks />
                <Text>
                  The course really helped me to get into the mindset of the SJT which I think is the key. I think for the SJT it is not doing the most practice questions which helps, it is being guided to a particular thought process which this course helped me to do. I can say with confidence, that without this course I don't think I would have scored as highly and I am now about to begin working in my top choice deanery at my top choice job, so thank you!
                  <span>Zoe Spink</span>
                </Text>
              </Testimonial>
              <Testimonial>
                <SpeechMarks />
                <Text>
                  Having a structured method to answer questions was crucial and the course provided those techniques. Timing was also very important to get sorted. I would recommend this course to anyone. Thank you.
                  <span>Caitlin Culyer</span>
                </Text>
              </Testimonial>
              <Testimonial>
                <SpeechMarks />
                <Text>
                  The SJT preparation team were really knowledgeable and the resources available definitely helped me score highly.
                  <span>Christopher Rimmer</span>
                </Text>
              </Testimonial>
              <Testimonial>
                <SpeechMarks />
                <Text>
                  Thought this was a great course. I thought it was a lot better than other courses that I did that I paid more money for
                  <span>Tamarind Russel-Webster</span>
                </Text>
              </Testimonial>
              <Testimonial>
                <SpeechMarks />
                <Text>
                  This course is useful for understanding the layout of the exam, and most importantly, the timing! As that's the biggest constraint.
                  <span>Shannon Flynn</span>
                </Text>
              </Testimonial>
              <Testimonial>
                <SpeechMarks />
                <Text>
                  Thank you so much SJT Preparation for making me feel confident in taking my SJT exam and enabling me to achieve my deanery and job of choice!
                  <span>Abigail Stewart</span>
                </Text>
              </Testimonial>
            </div>
            <div>
              <Testimonial>
                <SpeechMarks />
                <Text>
                  Out of all the resources out there, I feel that I got the most out of this course, the mock was fantastic.
                  <span>Maurice Samake</span>
                </Text>
              </Testimonial>
              <Testimonial>
                <SpeechMarks />
                <Text>
                  Was very useful. The only resource which helped to cover the new style of exam questions. Will be recommending to all my friends!
                  <span>Robyn Wilcha</span>
                </Text>
              </Testimonial>
              <Testimonial>
                <SpeechMarks />
                <Text>
                  I would really recommend doing the SJT Preparation course. I found it extremely useful and I truly believed it helped me to get to my first choice Foundation School. Thank you!
                  <span>Amy Nolan</span>
                </Text>
              </Testimonial>
              <Testimonial>
                <SpeechMarks />
                <Text>
                  I think the course really helped me get a good score
                  <span>Fiona McDonald</span>
                </Text>
              </Testimonial>
              <Testimonial>
                <SpeechMarks />
                <Text>
                  Super helpful course - calming nerves and helping shape a good exam technique. Was apprehensive about the cost but money well spent, especially when you consider how many thousands of pounds we pay for Medical School. Definitely helped me secure my top deanery and second choice of job! Would highly recommend!
                  <span>Jennifer Alice Cahill</span>
                </Text>
              </Testimonial>
              <Testimonial>
                <SpeechMarks />
                <Text>
                  Very useful course. The questions and explanations were helpful and I felt it prepared me well for my SJT. Would strongly recommend
                  <span>Asha Rattan</span>
                </Text>
              </Testimonial>
              <Testimonial>
                <SpeechMarks />
                <Text>
                  Brilliant teaching, perfect preparation for the exam, especially the mock exam
                  <span>Jessica Dowle</span>
                </Text>
              </Testimonial>
              <Testimonial>
                <SpeechMarks />
                <Text>
                  Really good on-the-day lectures. They were engaging and very useful for good preparation. Went into the exam feeling confident.
                  <span>Rebecca Warren</span>
                </Text>
              </Testimonial>
            </div>
          </Groups>

          <Groups>
            <div>
              <Testimonial>
                <SpeechMarks />
                <Text>
                  Really good day. Feel a lot more prepared for the SJT. Thank you! SJT well explained from an FY1 point
                  of view. A Sunday well spent!
                  <span>Jade Singh</span>
                </Text>
              </Testimonial>
              <Testimonial>
                <SpeechMarks />
                <Text>
                  This course was of a much better standard than another course I went on. The presenters + questions
                  were much more closely aligned with SJT sample questions. <span>Venetia Allan</span>
                </Text>
              </Testimonial>
              <Testimonial>
                <SpeechMarks />
                <Text>
                  Really useful course + greatly increased my knowledge of what to expect for the SJT.
                  <span>Emily Ross</span>
                </Text>
              </Testimonial>
              <Testimonial>
                <SpeechMarks />
                <Text>
                  A very thorough and organised course. Gives a good grounding and places candidate in a good position
                  in preparation for the SJT. Having gone through questions individually, it gives a good idea of what
                  is required to approach the SJT. A very good course and highly recommend to others!{' '}
                  <span>Rahim Tabassum</span>
                </Text>
              </Testimonial>
              <Testimonial>
                <SpeechMarks />
                <Text>
                  Very detailed run through of core domains with good explanations.
                  <span>Brendan Chan</span>
                </Text>
              </Testimonial>
              <Testimonial>
                <SpeechMarks />
                <Text>
                  I feel much more prepared for the SJT after this course. It was really helpful doing questions in an
                  environment where you could discuss the issues afterwards. <span>Lindsay McCall</span>
                </Text>
              </Testimonial>
              <Testimonial>
                <SpeechMarks />
                <Text>
                  Excellent. Really well structured. Very good teaching.
                  <span>Genevieve Vanderslott</span>
                </Text>
              </Testimonial>
              <Testimonial>
                <SpeechMarks />
                <Text>
                  Very useful in understanding what the SJT covers and how to approach the exam. Most useful: The
                  breakdown of questions and explanations on how they relate to GMC governance{' '}
                  <span>Yallan Nimalathas</span>
                </Text>
              </Testimonial>
              <Testimonial>
                <SpeechMarks />
                <Text>
                  I have really enjoyed the course today. I have learned a lot and feel a lot more prepared! Thank you.{' '}
                  <span>Anna Chisholm</span>
                </Text>
              </Testimonial>
              <Testimonial>
                <SpeechMarks />
                <Text>
                  Very well organised and very comprehensive. <span>Matthew Donaldson</span>
                </Text>
              </Testimonial>

              <Testimonial>
                <SpeechMarks />
                <Text>
                  Very informative + engaging. Good explanations of reasoning <span>Shanvir Mann</span>
                </Text>
              </Testimonial>

              <Testimonial>
                <SpeechMarks />
                <Text>
                  Well organised. Lots covered. Good value for money. <span>Katherine Sissons</span>
                </Text>
              </Testimonial>

              <Testimonial>
                <SpeechMarks />
                <Text>
                  Really well prepared presenters. Through explanation. <span>Peter Boxall</span>
                </Text>
              </Testimonial>

              <Testimonial>
                <SpeechMarks />
                <Text>
                  Great structure. Good explanation. Very professional. <span>Andrew Martin</span>
                </Text>
              </Testimonial>

              <Testimonial>
                <SpeechMarks />
                <Text>
                  Very good overall. The structure is spot-on: concentrating on practice questions & immediate
                  discussion thereof plus some explicit mini-lectures on specific topics, e.g. ethics, capacity. Very
                  good idea to draw learning together under exam conditions. <span>Anthony Ian Taylor</span>
                </Text>
              </Testimonial>

              <Testimonial>
                <SpeechMarks />
                <Text>
                  Good course, thank you. The 1 hour exam at the end was unique, much better than other courses.{' '}
                  <span>Tharinda Disanayake</span>
                </Text>
              </Testimonial>

              <Testimonial>
                <SpeechMarks />
                <Text>
                  Very useful to gain information from the doctors about their jobs as FY1/2s which helps in answering
                  some of the SJT Q’s. Thanks. <span>Cindy liu</span>
                </Text>
              </Testimonial>

              <Testimonial>
                <SpeechMarks />
                <Text>
                  Useful to dedicate a whole day to it. Can now start preparing more effectively than I would have if I
                  had not done this course. <span>Rosie Byars</span>
                </Text>
              </Testimonial>

              <Testimonial>
                <SpeechMarks />
                <Text>
                  Very good opportunity to practice questions and discuss answers. Good balance between theory covering
                  core principles and questions. <span>Radhica Ohri</span>
                </Text>
              </Testimonial>

              <Testimonial>
                <SpeechMarks />
                <Text>
                  Great course. Really happy with programme. Questions based much more helpful than any other format.
                  Feel a lot more prepared. <span>Emma brown</span>
                </Text>
              </Testimonial>

              <Testimonial>
                <SpeechMarks />
                <Text>
                  It has been a really intensive day but I feel much more prepared for the SJT now.{' '}
                  <span>John Tjoakarfa</span>
                </Text>
              </Testimonial>

              <Testimonial>
                <SpeechMarks />
                <Text>
                  Really good course that coved all 5 domains from GMP. The practice mock paper was extremely useful.{' '}
                  <span>Arrani Nirmalanantha</span>
                </Text>
              </Testimonial>
            </div>
            <div>
              <Testimonial>
                <SpeechMarks />
                <Text>
                  Really useful style of teaching with Qs + explanation. Helpful to break down domain. Very good - thank
                  you. <span>Rebecca Fisher</span>
                </Text>
              </Testimonial>

              <Testimonial>
                <SpeechMarks />
                <Text>
                  A very good course. Definitely made me more prepared for the SJT. Format was really good + the fact
                  that we had lots of examples. <span>Mariam Ali</span>
                </Text>
              </Testimonial>

              <Testimonial>
                <SpeechMarks />
                <Text>
                  A very well structured and presented course. I feel much more confident in approaching the SJT now.{' '}
                  <span>John Soothill</span>
                </Text>
              </Testimonial>

              <Testimonial>
                <SpeechMarks />
                <Text>
                  Definitely worth coming to, the tips are great. <span>Nikhilesh Raut</span>
                </Text>
              </Testimonial>

              <Testimonial>
                <SpeechMarks />
                <Text>
                  Mock SJT is a great idea – people giving course are very good: easy to talk to and approachable.{' '}
                  <span>Edward Karam</span>
                </Text>
              </Testimonial>

              <Testimonial>
                <SpeechMarks />
                <Text>
                  Really useful + interesting day. Interactive + good explanations made it for more engaging and
                  extremely useful. I feel more clued up and calm with regards to how to approach the SJT.{' '}
                  <span>Rosie Harrison</span>
                </Text>
              </Testimonial>

              <Testimonial>
                <SpeechMarks />
                <Text>
                  Well presented & thought through. Better than the other SJT course I went on.{' '}
                  <span>Victoria Tyndall</span>
                </Text>
              </Testimonial>

              <Testimonial>
                <SpeechMarks />
                <Text>
                  Excellent thank you, very helpful to have the booklet with slides also. <span>Tavlene Banwaith</span>
                </Text>
              </Testimonial>

              <Testimonial>
                <SpeechMarks />
                <Text>
                  Excellent presentation style. Very approachable speakers :) Thank you for your help!{' '}
                  <span>Sarah Brennan</span>
                </Text>
              </Testimonial>

              <Testimonial>
                <SpeechMarks />
                <Text>
                  Really well delivered and mock paper was really beneficial especially as under exam pressure.{' '}
                  <span>Jill Liu</span>
                </Text>
              </Testimonial>

              <Testimonial>
                <SpeechMarks />
                <Text>
                  Clear and concise with lots of practice questions and good explanations. <span>Justin</span>
                </Text>
              </Testimonial>

              <Testimonial>
                <SpeechMarks />
                <Text>
                  Very good practice exam, very helpful. Good amount of breaks. Found your approach to the SJT very
                  helpful, logical, and unique (…) <span>Paul Pulavar</span>
                </Text>
              </Testimonial>

              <Testimonial>
                <SpeechMarks />
                <Text>
                  Very useful, very patient, and friendly with students. <span>Naomi Dennehey</span>
                </Text>
              </Testimonial>

              <Testimonial>
                <SpeechMarks />
                <Text>
                  Really good course, enjoyed and feel more confident! <span>Isaac Mayo</span>
                </Text>
              </Testimonial>

              <Testimonial>
                <SpeechMarks />
                <Text>
                  Useful practice :) would definitely recommend. <span>Jenny Stuart-Smith</span>
                </Text>
              </Testimonial>

              <Testimonial>
                <SpeechMarks />
                <Text>
                  Good structure, informed articulate speakers. <span>Nicholas Scallan</span>
                </Text>
              </Testimonial>

              <Testimonial>
                <SpeechMarks />
                <Text>
                  The layout of the course today was excellent. I liked that there was information other than SJT given
                  to us ie. Medicolegal and tips on being an FY1. Overall excellent. <span>Alanna Bruce</span>
                </Text>
              </Testimonial>

              <Testimonial>
                <SpeechMarks />
                <Text>
                  Very well organised. Discussed all relevant points. Practice exam very useful.{' '}
                  <span>Rebecca McCall</span>
                </Text>
              </Testimonial>

              <Testimonial>
                <SpeechMarks />
                <Text>
                  Good to have lots of practice questions to explain the different domains.{' '}
                  <span>Felicity Montgommery</span>
                </Text>
              </Testimonial>

              <Testimonial>
                <SpeechMarks />
                <Text>
                  Great format - very good overview of domains + well explained rationales for answers.{' '}
                  <span>Imogen John</span>
                </Text>
              </Testimonial>

              <Testimonial>
                <SpeechMarks />
                <Text>
                  Good structure to the course, course material such as the booklet very useful and helpful, presenters
                  were very helpful and pleasant. <span>Binay Gurung</span>
                </Text>
              </Testimonial>

              <Testimonial>
                <SpeechMarks />
                <Text>
                  Very good mix of interactive sessions + theory. Pratice questions with explanations were very useful
                  and helpful. Really enjoyed the course and appreciate the knowledge and professionalism.{' '}
                  <span>Arusa Latif</span>
                </Text>
              </Testimonial>

              <Testimonial>
                <SpeechMarks />
                <Text>
                  Really good, I know now how to approach questions + can concentrate on practicing.{' '}
                  <span>Eve Laycock</span>
                </Text>
              </Testimonial>
            </div>
          </Groups>
        </Container>
      </Wrapper>
    );
  }
}

export default Feedback;
